module.exports = __webpack_public_path__ + "img/close-black.a93b036e.svg";